import React, { useEffect, useState } from 'react';
import { ConstructorEventUpdateSQLStatus } from '../../../../Event/event';

const GuessOperationGame = () => {
  const [riddle, setRiddle] = useState('Loading...');
  const [feedback, setFeedback] = useState('');
  const [hint, setHint] = useState('');
  const [showHint, setShowHint] = useState(false);
  const [currentRiddle, setCurrentRiddle] = useState({});
  const [wrongTry, setWrongTry] = useState(false);

  const riddles = [
    (a, b) => ({
      text: `A tree had ${a} apples. ${b} fell down. What operation tells how many are left?`,
      answer: '-',
      hint: 'Think of what we do when something is taken away.'
    }),
    (a, b) => ({
      text: `Each basket has ${a} mangoes. There are ${b} baskets. What operation gives total mangoes?`,
      answer: '*',
      hint: 'When you have groups of equal things, what do you do?'
    }),
    (a, b) => ({
      text: `John had ${a} candies. He gave ${b} to his friend. What operation?`,
      answer: '-',
      hint: 'Gave away = reduce'
    }),
    (a, b) => ({
      text: `A classroom has ${a} students. They are split equally into ${b} teams. What operation?`,
      answer: '/',
      hint: 'Splitting equally is what operation?'
    }),
    (a, b) => ({
      text: `Sara found ${a} seashells and bought ${b} more. Which operation finds the total?`,
      answer: '+',
      hint: 'Adding to what you already have?'
    }),
  ];

  const correctSound = new Audio("https://cdn.pixabay.com/audio/2022/03/15/audio_7a37e66126.mp3");
  const wrongSound = new Audio("https://cdn.pixabay.com/audio/2022/03/15/audio_63e6b776b2.mp3");

  const getRandomNumber = (min, max) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  };

  const generateRiddle = () => {
    const riddleFunc = riddles[Math.floor(Math.random() * riddles.length)];
    const a = getRandomNumber(2, 10);
    const b = getRandomNumber(1, a);
    const newRiddle = riddleFunc(a, b);
    setCurrentRiddle(newRiddle);
    setRiddle(newRiddle.text);
    setFeedback('');
    setHint('');
    setShowHint(false);
    setWrongTry(false);
  };

  const checkAnswer = (op) => {
    if (op === currentRiddle.answer) {
      setFeedback('✅ Correct!');
      correctSound.play();
      const responsedata = ConstructorEventUpdateSQLStatus();
      console.log("Event completed", responsedata);
      setTimeout(() => generateRiddle(), 1200);
    } else {
      setFeedback('❌ Try again!');
      wrongSound.play();
      if (!wrongTry) {
        setHint(`🧠 Hint: ${currentRiddle.hint}`);
        setShowHint(true);
        setWrongTry(true);
      }
    }
  };

  useEffect(() => {
    generateRiddle();
  }, []);

  return (
    <div style={{
      fontFamily: 'Comic Sans MS, cursive, sans-serif',
      background: 'linear-gradient(to right, #e0f7fa, #f1f8e9)',
      textAlign: 'center',
      padding: '2rem',
      minHeight: '100vh',
    }}>
      <style>{`
        @media (max-width: 600px) {
          .riddle-box {
            padding: 1rem !important;
          }
          .riddle-text {
            font-size: 1.2rem !important;
          }
          .op-btn {
            font-size: 1.5rem !important;
            padding: 0.6rem 1rem !important;
          }
        }
      `}</style>

      <div className="riddle-box" style={{
        maxWidth: '600px',
        margin: 'auto',
        border: '3px dashed #4caf50',
        borderRadius: '20px',
        padding: '2rem',
        background: '#ffffffee',
        boxShadow: '0 10px 20px rgba(0,0,0,0.1)'
      }}>
        <div className="riddle-text" style={{
          fontSize: '1.6rem',
          color: '#333',
          marginBottom: '1.5rem'
        }}>
          {riddle}
        </div>

        <div>
          {['+', '-', '*', '/'].map(op => (
            <button
              key={op}
              className="op-btn"
              onClick={() => checkAnswer(op)}
              style={{
                fontSize: '2rem',
                margin: '10px',
                padding: '0.8rem 1.2rem',
                border: 'none',
                borderRadius: '12px',
                background: '#4caf50',
                color: 'white',
                cursor: 'pointer',
                transition: 'transform 0.2s, background 0.3s'
              }}
              onMouseOver={e => e.currentTarget.style.transform = 'scale(1.1)'}
              onMouseOut={e => e.currentTarget.style.transform = 'scale(1)'}
            >
              {op === '+' && '➕'}
              {op === '-' && '➖'}
              {op === '*' && '✖️'}
              {op === '/' && '➗'}
            </button>
          ))}
        </div>

        <div style={{ fontSize: '1.6rem', marginTop: '1rem' }}>{feedback}</div>
        {showHint && <div style={{ fontSize: '1.1rem', color: '#777', marginTop: '0.5rem' }}>{hint}</div>}
      </div>
    </div>
  );
};

export default GuessOperationGame;
